import styled from "styled-components";
import Logo from '../../assets/logo.svg';
import { RiUserAddLine } from "react-icons/ri";
import { CiLogin, CiUser } from "react-icons/ci";
import {Button} from "@chakra-ui/react";
import {DialogRoot, DialogTrigger} from "../../components/ui/dialog";
import RegisterDialog from "./register-dialog";
import {useContext} from "react";
import {AuthContext} from "../../contexts/auth-context";
import { CiLogout, CiSearch } from "react-icons/ci";
import {firebaseApp} from "../../firebase/firebase";
import {getAuth, signOut} from "firebase/auth";
import {toaster} from "../../components/ui/toaster";
import LoginDialog from "./login-dialog";
import {Link, NavLink} from "react-router";
import {responsive} from "../../media-quries";

const Container = styled.div`
  padding: 8px 0;
  width: 100vw;
  left: 0;
  min-height: 80px;
  position: fixed;
  top: 0;
  background: rgba(255, 255, 255, 0.4); /* Półprzezroczyste tło */
  backdrop-filter: blur(10px); /* Rozmycie tła */
  -webkit-backdrop-filter: blur(10px); /* Obsługa dla Safari */
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Delikatny cień */
  z-index: 1000; /* Nad innymi elementami */
`;
const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-self: center;
  justify-content: space-between;

  /* Mobile: Do 767px */
  @media (max-width: 767px) {
    max-width: 100%; /* Full width dla mobile */
    padding: 0 16px; /* Standardowy padding */
  }

  /* Tablet: 768px - 1023px */
  @media (min-width: 768px) and (max-width: 1023px) {
    max-width: 720px; /* Szerokość contentu dla tabletów */
  }

  /* Laptop: 1024px - 1279px */
  @media (min-width: 1024px) and (max-width: 1279px) {
    max-width: 960px; /* Szerokość contentu dla laptopów */
  }

  /* Desktop: 1280px - 1919px */
  @media (min-width: 1280px) and (max-width: 1919px) {
    max-width: 1140px; /* Szerokość contentu dla desktopów */
  }

  /* Large Desktop: 1920px i więcej */
  @media (min-width: 1920px) {
    max-width: 1440px; /* Szerokość contentu dla dużych ekranów */
  }
`;

const AccountWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
`;
const LogoContainer = styled(Link)`
  flex: 1;
  display: flex;
  min-width: 150px;

  ${responsive.md`
    align-items: center;
  justify-content: center;
  `}

  ${responsive.sm`
    align-items: center;
  justify-content: center;
  `}
`;

const auth = getAuth(firebaseApp);
function Navigation() {
    const { user } = useContext(AuthContext);
    const onSignOut = () => {
        signOut(auth)
            .then(() => {
                toaster.create({
                    title: 'Zostałeś wylogowany',
                    type: 'success',
                })
            })
            .catch((error) => {
                toaster.create({
                    title: 'Wystąpił problem podczas wylogowywania. Spróbuj ponownie później',
                    type: 'error',
                })
            });
    }

    return <Container className="navigation-bar">
        <Wrapper>
            <LogoContainer to="/">
                <img src={Logo} width="150" alt="Geoksiegi logo"  />
            </LogoContainer>
            <AccountWrapper>
                <NavLink to="/">
                    <Button variant="plain" onClick={() => window.scrollTo(0, 0)}>
                        <CiSearch /> WYSZUKAJ KSIĘGĘ
                    </Button>
                </NavLink>
                {!user && <>
                    <DialogRoot>
                        <DialogTrigger asChild>
                            <Button variant="plain">
                                <CiLogin /> LOGOWANIE
                            </Button>
                        </DialogTrigger>
                        <LoginDialog />
                    </DialogRoot>
                    <DialogRoot>
                        <DialogTrigger asChild>
                            <Button variant="plain">
                                <RiUserAddLine /> REJESTRACJA
                            </Button>
                        </DialogTrigger>
                        <RegisterDialog />
                    </DialogRoot>
                </>}
                {user && <>
                    <NavLink to="/panel-uzytkownika">
                        <Button variant="plain">
                            <CiUser /> PANEL UŻYTKOWNIKA
                        </Button>
                    </NavLink>
                    <Button
                        onClick={onSignOut}
                        variant="plain"
                    >
                        <CiLogout /> WYLOGUJ
                    </Button>
                </>}
            </AccountWrapper>
        </Wrapper>
    </Container>

}

export default Navigation;
